<template>
    <el-col :span="24" class="el-form-item--large" :class="className" v-show="defaultShow">
        <el-row>
            <el-col 
                v-for="(cellitem,index) in settings.Childrens" 
                :key="index" 
                :xs="{span:24}" 
                :md="md(cellitem)" 
                v-show="cellitem.Display">
                <el-row>
                    <component v-for="(field,index) in cellitem.Components"
                                :key="field.Name"
                                :is="field.FieldDefinition.Name"
                                :definition="field"
                                :data="data"
                                :htmlPrefix="htmlPrefix"
                                :contentType="contentType"
                                :formDefinition = "formDefinition"
                                :orginalDisplay = "orginalDisplay">
                    </component>
                </el-row>
            </el-col>
        </el-row>
    </el-col>
</template>

<script>
    import BaseLayout from "./LayoutBase";
    export default {
        name:"qweGrids",
        mixins: [BaseLayout],
        
        methods:{
            md:function(cell){
                return {
                    span:cell.Width,
                    offset:cell.Offset
                }
            }
        }
    }
</script>